import Img from '../components/Img';
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import Button from '@mui/material/Button';

const PermanentMakeupRemoval: React.FC = () => {
  return (
    <>
    <Helmet>
      <title>Permanent Makeup Removal in Wrentham, MA | Atomic Tattoo Removal</title>
      <meta name="description" content="Safe laser removal of permanent makeup — eyebrows, eyeliner, and lip liner — in Wrentham, MA. Free consultations at Atomic Tattoo Removal." />
      <meta name="keywords" content="permanent makeup removal, cosmetic tattoo removal, eyebrow tattoo removal, lip liner removal, Wrentham MA, laser makeup removal" />
      <meta property="og:title" content="Permanent Makeup Removal in Wrentham, MA | Atomic Tattoo Removal" />
      <meta property="og:description" content="Safe laser removal of permanent makeup — eyebrows, eyeliner, and lip liner — in Wrentham, MA. Free consultations at Atomic Tattoo Removal." />
      <meta property="og:image" content="https://www.atomictattooremoval.com/assets/permanent-makeup-removal.jpg" />
      <meta property="og:url" content="https://www.atomictattooremoval.com/permanent-makeup-removal" />
    </Helmet>
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', textAlign: 'justify' }}>
      <h1 style={{ color: '#cb4f2e', textAlign: 'center', marginBottom: '20px' }}>
        Permanent Makeup Removal in Wrentham, MA
      </h1>
      <h2 style={{ color: '#5C96AC', textAlign: 'center', marginBottom: '20px' }}>
        Refine Your Look with Expert Care
      </h2>
      <p>
        If you're seeking to remove or adjust permanent makeup, Atomic Tattoo Removal offers specialized laser treatments designed to safely and effectively address cosmetic tattoos, including eyebrows, and lip liner.
      </p>
        <Img
          src="/assets/permanent-makeup-removal.jpg"
          alt="Permanent makeup removal procedure"
          style={{ maxWidth: '100%', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
        />      
      <h3 style={{ color: '#cb4f2e', marginTop: '30px' }}>Safe and Effective Removal Process</h3>
      <p>
        Our laser technology targets the pigments used in permanent makeup, breaking them down so your body can naturally eliminate them. The process is similar to traditional tattoo removal but requires specialized techniques due to the sensitive areas involved.
      </p>
      <h3 style={{ color: '#cb4f2e', marginTop: '30px' }}>Treatment Details</h3>
      <ul style={{ paddingLeft: '20px' }}>
        <li>
          <strong>Consultation:</strong> We'll evaluate your permanent makeup and discuss your desired outcome.
        </li>
        <li>
          <strong>Treatment Sessions:</strong> Sessions typically last between 10 to 30 minutes. The number of sessions needed varies based on factors like pigment depth and color.
        </li>
        <li>
          <strong>Aftercare:</strong> Proper aftercare is crucial. We'll provide comprehensive instructions to promote healing and minimize risks.
        </li>
      </ul>
      <h3 style={{ color: '#cb4f2e', marginTop: '30px' }}>Why Trust Atomic Tattoo Removal?</h3>
      <ul style={{ paddingLeft: '20px' }}>
        <li>
          <strong>Specialized Expertise:</strong> Our team has experience in removing various types of permanent makeup with precision.
        </li>
        <li>
          <strong>Customized Approach:</strong> We develop individualized treatment plans to achieve your specific goals.
        </li>
        <li>
          <strong>Commitment to Safety:</strong> We adhere to strict safety protocols to ensure the best possible outcomes.
        </li>
      </ul>
      <p style={{ marginTop: '20px' }}>
        Let us help you refine your appearance with confidence. Schedule your free consultation today to learn more about our permanent makeup removal services.
      </p>
      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <Link to="/book-consultation" style={{ textDecoration: 'none' }}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'book_now_click',
                button_location: 'permanent_makeup_removal_page', 
              });
            }}
            sx={{
              color: '#f0e9d4',
              '&:hover': { color: '#ffffff', backgroundColor: '#cb4f2e' },
            }}
          >
            Schedule Your Free Consultation
          </Button>
        </Link>
      </div>
    </div>
    </>
  );
};

export default PermanentMakeupRemoval;